import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type DiscardExerciseChangesModalProps = {
  show: boolean;
  onHide: () => void;
  onDiscard: () => void;
};

export const DiscardExerciseChangesModal = (props: DiscardExerciseChangesModalProps) => (
  <Dialog open={props.show} onClose={props.onHide} aria-labelledby="discard-exercise-title" aria-describedby="discard-exercise-description">
    <DialogTitle id="discard-exercise-title">Discard changes?</DialogTitle>
    <DialogContent>
      <DialogContentText id="discard-exercise-description">Are you sure you want to leave? Any unsaved changes will be lost.</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button autoFocus onClick={props.onHide}>
        Keep editing
      </Button>
      <Button color="error" onClick={props.onDiscard}>
        Discard changes
      </Button>
    </DialogActions>
  </Dialog>
);
